import { getTodayDateString } from 'components/inputs/dateHelpers';
import { ScheduledDashboardEmailConfig } from 'components/DashboardSendModal/ScheduledDashboardEmailConfigForm/types';

export const shouldSendEmailRightAway = (
    config: ScheduledDashboardEmailConfig,
): boolean => config.firstSentDate === getTodayDateString();
